module.exports = __webpack_public_path__ + "client/img/world_07.1929f210.png";